module.exports = __webpack_public_path__ + "img/[强].12ea6d3c.svg";